import styles from './HeaderBig.module.css';
import { Link } from 'react-router-dom';
import NavMenu from '../NavMenu/NavMenu';
import NavIcons from '../NavIcons/NavIcons';
import { useTranslation } from 'react-i18next';

const HeaderBig = () => {
  const { t } = useTranslation();

  // useEffect(() => {
  //   const lng = navigator.language;

  //   i18n.changeLanguage(lng);
  // }, []);
  return (
    <header className={styles.header} role='banner'>
      <div className={styles.menuContainer}>
        <h1>
          <Link to='/' className={styles.title}>
            {t('lang.homeTitle')}
          </Link>
        </h1>

        <div className={styles.textContainer}>
          <p>{t('lang.homeSubTitle')}</p>
        </div>
        <NavMenu menuBig='1' />
        <NavIcons />
      </div>
    </header>
  );
};

export default HeaderBig;
